BatchGeoStore.addReducer("Printer", function (state, action) {
  state = state || {
    active: false,
    zoom: null,
    bounds: null,
  };

  switch (action.type) {
    case "PRINTER_ACTIVATE":
      return _.merge({}, state, {
        active: true,
      });
    case "PRINTER_DEACTIVATE":
      return _.merge({}, state, {
        active: false,
      });
    case "PRINTER_MAP_STATE_SAVE":
      return _.merge({}, state, {
        zoom: action.zoom,
        bounds: action.bounds,
      });
    default:
      return state;
  }
});
